export const inr = (n) =>
  n == null || n === "" ? "-" : "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const formatCell = (type, v) => {
  if (type === "currency") return inr(v);
  if (type === "boolean") return v ? "Yes" : "No";
  if (type === "date") return fmtDate(v);
  if (type === "datetime") return fmtDateTime(v);
  if (v == null || v === "") return "-";
  return String(v);
};
